import { render, staticRenderFns } from "./SaCheckbox.vue?vue&type=template&id=15e73a36&"
import script from "./SaCheckbox.vue?vue&type=script&lang=js&"
export * from "./SaCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports